
import Header from '../../components/feature/Header';
import Footer from '../../components/feature/Footer';
import NewsHeroSection from './components/NewsHeroSection';
import FeaturedNewsSection from './components/FeaturedNewsSection';
import NewsGridSection from './components/NewsGridSection';
import NewsletterSection from './components/NewsletterSection';
import NewsArchiveSection from './components/NewsArchiveSection';

export default function News() {
  return (
    <div className="min-h-screen bg-white">
      <Header />
      <main>
        <NewsHeroSection />
        <FeaturedNewsSection />
        <NewsGridSection />
        <NewsArchiveSection />
        <NewsletterSection />
      </main>
      <Footer />
    </div>
  );
}
